import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  popover: {
    "& .MuiPopover-paper": {
      backgroundColor: theme.palette.background100,
      borderRadius: theme.radius.radius300,
    },
  },
  colorPicker: {
    minWidth: 276,
    minHeight: 172,
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: 16,
    padding: 16,
    backgroundColor: theme.palette.background100,
    borderRadius: theme.radius.radius300,
    border: `1px solid ${theme.palette.neutral200}`,
  },
}))

export default useStyles
